// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Card_clearfix__Q4RI5","ellipsis":"Card_ellipsis__1Mg8U","hide":"Card_hide__2lRSY"};